import useInstance from './useInstance'

export default () => {
  const amplitudeInstance = useInstance()
  return amplitudeInstance.setUserProperties.bind(amplitudeInstance)
}
